import { Tabs, Card, message } from 'antd';
import React, { useState, useRef } from 'react';
import { LocalPersistence } from '../../../factories';
import { addAmenityservice } from '../../../services/amenityservice';
import AddPage from './AddPageInfo';
// import AddAccessibilityAndSecurity from './AccessibilityAndSecurity/AddAccessibilityAndSecurity';
import AddScheduleAndCharge from './ScheduleAndCharge/AddScheduleAndCharge';
import Loading from '../../Loading';
import PageContainer from '../../CSIComponents/PageContainer';
import ActionButtonsBar from '../../ui/ActionButtonsBar';
import AccessibilityAndSecurity from './AccessibilityAndSecurity/index';

const { TabPane } = Tabs;
interface propsTypes {
  isEditable?: void | any;
  cancelEditable?: void | any;
  disableTabPanes?: void | any;
  detail?: any;
  cancelAndSave?: void | any;
}

const AddPageTab = (props: propsTypes) => {
  const disabledFlag = false;
  const [addLoading, setAddLoading] = useState(false);
  //const [transferData,setTransferData] = useState([]);

  const AddDetailRef = useRef<any>();
  const AddScheduleAndChargeRef = useRef<any>();
  const [transferDataAll, setTransferDataAll] = useState([]);
  const [disabledStatus, setDisabledStatus] = useState(true);

  const getTransferData = (data: any) => {
    setTransferDataAll(data);
  };

  const handlCancelClick = () => {
    props.cancelAndSave();
  };

  const validateFieldsError = (isDisabled?: boolean) => {
    if (isDisabled) {
      setDisabledStatus(isDisabled);
      return;
    }
    Promise.all([
      AddDetailRef.current.detailForm.validateFields(),
      AddScheduleAndChargeRef.current.scheduForm.validateFields(),
      // AddAccessibilityAndSecurityRef.current.securityForm.validateFields(),
    ])
      .then(() => {
        setDisabledStatus(false);
      })
      .catch(() => {
        const detailErrNum = AddDetailRef?.current?.detailForm
          ?.getFieldsError()
          ?.filter(({ errors }: { errors: any }) => errors.length).length;

        const scheduleErrNum = AddScheduleAndChargeRef?.current?.scheduForm
          ?.getFieldsError()
          ?.filter(({ errors }: { errors: any }) => errors.length).length;

        /* const accessibilityErrNum =
          AddAccessibilityAndSecurityRef?.current?.securityForm
            ?.getFieldsError()
            ?.filter(({ errors }: { errors: any }) => errors.length).length; */

        const errTotalNum = detailErrNum + scheduleErrNum;

        console.log(detailErrNum, scheduleErrNum);

        if (errTotalNum === 0) {
          setDisabledStatus(false);
        } else {
          setDisabledStatus(true);
        }
      });
  };

  const addSave = async () => {
    const get_session = new LocalPersistence('session');
    const session: any = await get_session.getSessionPersistence();

    Promise.all([
      AddDetailRef.current.detailForm.validateFields(),
      AddScheduleAndChargeRef.current.scheduForm.validateFields(),
      // AddAccessibilityAndSecurityRef.current.securityForm.validateFields(),
    ])
      .then(async (value) => {
        if (transferDataAll.length > 0) {
          value[0].tags = transferDataAll.join(' | ');
        }
        for (let key in value[1]) {
          if (
            value[1][key].startDatePicker &&
            value[1][key].startDatePicker.length > 0
          ) {
            value[1][key].startdate =
              value[1][key].startDatePicker[0].format('MM/DD/YYYY');
            value[1][key].enddate =
              value[1][key].startDatePicker[1].format('MM/DD/YYYY');
          } else if (value[1][key].startDatePicker == undefined) {
            value[1][key].startdate = '';
            value[1][key].enddate = '';
          }

          for (let i = 0; i < value[1][key].operationtime.length; i++) {
            if (i === 0) {
              value[1][key].operationtime[i].dayoftheweek = 'Mon';
            } else if (i === 1) {
              value[1][key].operationtime[i].dayoftheweek = 'Tue';
            } else if (i === 2) {
              value[1][key].operationtime[i].dayoftheweek = 'Wed';
            } else if (i === 3) {
              value[1][key].operationtime[i].dayoftheweek = 'Thu';
            } else if (i === 4) {
              value[1][key].operationtime[i].dayoftheweek = 'Fri';
            } else if (i === 5) {
              value[1][key].operationtime[i].dayoftheweek = 'Sat';
            } else if (i === 6) {
              value[1][key].operationtime[i].dayoftheweek = 'Sun';
            }
            if (
              value[1][key].operationtime[i].endtime !== '' &&
              value[1][key].operationtime[i].endtime !== undefined
            ) {
              value[1][key].operationtime[i].endtime =
                value[1][key].operationtime[i].endtime.format('HH:mm');
            }
            if (
              value[1][key].operationtime[i].starttime !== '' &&
              value[1][key].operationtime[i].starttime !== undefined
            ) {
              value[1][key].operationtime[i].starttime =
                value[1][key].operationtime[i].starttime.format('HH:mm');
            }
          }
        }

        let scheduleData = [];
        // let securityData = [];
        for (let k in value[1]) {
          for (let i = 0; i < value[1][k].charge.length; i++) {
            if (value[1][k].charge[i] == undefined) {
              value[1][k].charge.splice(i, 1);
              i--;
            } else {
              if (value[1][k].charge[i].type == undefined) {
                value[1][k].charge[i].type = '';
              }
              if (value[1][k].charge[i].chargefrequency == undefined) {
                value[1][k].charge[i].chargefrequency = '';
              }
              if (value[1][k].charge[i].chargefrequency == undefined) {
                value[1][k].charge[i].chargefrequency = '';
              }
            }
          }
          scheduleData.push(value[1][k]);
        }

        /* for (let key in value[2]) {
          securityData.push(value[2][key]);
        } */

        let bodyData = {
          supplier: session.supplier,
          propertyId: session.propertyId,
          property: {
            amenityservice: [
              {
                name: value[0].name,
                category: value[0].category,
                type: value[0].type,
                lanyoncomments: value[0].lanyoncomments,
                included:
                  value[0].included === undefined ? '' : value[0].included,
                proximity: value[0].proximity,
                typedetail: value[0].typedetail,
                avail: value[0].avail === undefined ? '' : value[0].avail,
                id: value[0].id,
                quantity:
                  value[0].quantity === undefined ? '' : value[0].quantity,
                distance:
                  value[0].distance === undefined ? '' : value[0].distance,
                uom: value[0].uom === undefined ? '' : value[0].uom,
                tags: value[0].tags,
                schedule: scheduleData,
                // security: securityData,
              },
            ],
          },
        };
        setAddLoading(true);
        const res = await addAmenityservice(bodyData);
        if (res.result.success) {
          setAddLoading(false);
          console.log(res);
          props.cancelAndSave();
        } else {
          message.error({
            content: res?.error[0]?.message || 'operation failed',
          });
        }
      })
      .catch(() => {
        setAddLoading(false);
        message.error({
          content: 'Check all the fields please.',
        });
      });
  };
  if (addLoading) return <Loading type="large" />;
  return (
    <PageContainer>
      <Card style={{ marginBottom: '60px' }}>
        <Tabs defaultActiveKey="1">
          <TabPane
            tab="Detail"
            key="1"
            disabled={disabledFlag}
            forceRender={true}
          >
            <AddPage
              getTransferData={getTransferData}
              cancelAndSave={props.cancelAndSave}
              {...props}
              ref={AddDetailRef}
              validateFieldsError={validateFieldsError}
            />
            <ActionButtonsBar
              onCancel={handlCancelClick}
              onSave={addSave}
              disabledSave={disabledStatus}
              alertMsg={true}
              message={
                'Please complete the Detail section and save which will enable the Accessibility/Security pages'
              }
            />
          </TabPane>
          <TabPane
            tab="Schedule & Charge"
            key="2"
            disabled={true}
            forceRender={true}
          >
            <AddScheduleAndCharge
              cancelAndSave={props.cancelAndSave}
              {...props}
              ref={AddScheduleAndChargeRef}
              validateFieldsError={validateFieldsError}
            />
            <ActionButtonsBar
              onCancel={handlCancelClick}
              onSave={addSave}
              disabledSave={disabledStatus}
              warningMsg={true}
            />
          </TabPane>
          <TabPane
            tab="Accessibility/Security"
            key="3"
            disabled={true}
            forceRender={true}
          >
            {/* <AddAccessibilityAndSecurity
              cancelAndSave={props.cancelAndSave}
              {...props}
              ref={AddAccessibilityAndSecurityRef}
              validateFieldsError={validateFieldsError}
            /> */}
            <AccessibilityAndSecurity
              // setDisabledFlag={setDisabledFlag}
              isEditable={props.isEditable}
              cancelEditable={props.cancelEditable}
              cancelAndSave={props.cancelAndSave}
              {...props}
              // @ts-expect-error
              scheduleAndChargeData={{ security: [] }}
            />
          </TabPane>
        </Tabs>
      </Card>
    </PageContainer>
  );
};

export default AddPageTab;
